import { wixSearch } from '@wix-platform/secondary-header'

$w.onReady(function () {
	wixSearch($w('#secondaryHeader'), $w('#blogWixSearchController'), $w('#blogWixSearch'))
});